module.exports = __webpack_public_path__ + "img/haiti.8a181e6f.png";